export const SET_LOADING = "SET_LOADING"
export const SET_LOADING_OFF = "SET_LOADING_OFF"

export const LOGIN = "LOGIN"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILURE = "LOGIN_FAILURE"
export const LOGOUT = "LOGOUT"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
